<template>
  <div class="tips q-mb-sm">
    <div>
      <strong>Create a Link:</strong><br />
      (e.g. <a href="yellowBanner">Play Now</a> )
      <span style="color: red">
        <strong>-></strong>
      </span>
      &#60;a href="www.google.com"&#62;Play Now&#60;/a&#62;<br />
      *NOTE: if want the link to open a new tab, add (
      <em>target=”_blank”</em> ) after the href
    </div>
    <div class="q-mt-sm">
      <strong>Bold Text: </strong><br />
      (e.g. <strong>Bold text</strong> )
      <span style="color: red">
        <strong>-></strong>
      </span>
      &#60;strong&#62;Bold text&#60;/strong&#62;<br />
    </div>
    <div class="q-mt-sm">
      <strong>Underscore Text: </strong><br />
      (e.g. <u>Underscore text</u> )
      <span style="color: red">
        <strong>-></strong>
      </span>
      &#60;u&#62;Underscore text&#60;/u&#62;<br />
    </div>
    <div class="q-mt-sm">
      <strong>Italic Text: </strong><br />
      (e.g. <em>Italic text</em> )
      <span style="color: red">
        <strong>-></strong>
      </span>
      &#60;em&#62;Italic text&#60;/em&#62;<br />
    </div>
    <div class="q-mt-sm">
      <strong>BreakLine: </strong><br />
      <span style="color: red">
        <strong>-></strong>
      </span>
      &#60;br /&#62;<br />
      where you want to break the line
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tips {
  max-width: 90%;
}
</style>
